<div class="crm-dialog data-preview-dialog">
  <div mat-dialog-title class="dialog-title">
    <mat-icon>preview</mat-icon>
    <span>Adatfeltöltés Előnézet</span>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="preview-summary">
      <h3>Összefoglaló</h3>
      <p>
        <strong>{{getTotalRowCount()}}</strong> Excel sor lesz feldolgozva
        <strong>{{getTableCount()}}</strong> táblába.
        <span class="preview-note">(Előnézet: {{data.processedData.length}} sor)</span>
      </p>
      <div class="record-count-summary">
        <div class="summary-item">
          <span class="summary-label">Alaprekordok:</span>
          <span class="summary-value">{{getBaseRecordCount()}}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Többértékű rekordok:</span>
          <span class="summary-value">{{getMultiValueRecordCount()}}</span>
        </div>
        <div class="summary-item total">
          <span class="summary-label">Összes új rekord:</span>
          <span class="summary-value">{{getTotalRecordCount()}}</span>
        </div>
      </div>
      @if (data.enrichExisting) {
        <p class="enrich-active">
          <mat-icon>extension</mat-icon>
          Meglévő rekordok kiegészítése aktív: a már létező cégek nem maradnak ki, hanem kiegészülnek.
        </p>
      }
    </div>

    <mat-tab-group class="preview-tabs">
      <!-- Részletes rekord nézet -->
      <mat-tab label="Részletes rekord nézet">
        <div class="detailed-view">
          @for (record of data.processedData | slice:0:3; track record; let i = $index) {
            <div class="detailed-record-container">
              <h3 class="excel-row-header">
                <mat-icon>table_rows</mat-icon>
                {{record.rowIndex}}. Excel sor adatai
              </h3>
              @for (detailedTable of record.detailedRecords; track detailedTable) {
                <div class="detailed-table-section">
                  <h4 class="table-title">{{detailedTable.tableLabel}}</h4>
                  @for (detailRecord of detailedTable.records; track detailRecord; let recordIndex = $index) {
                    <div
                      class="detailed-record-item">
                      <div class="record-fields">
                        @for (fieldKey of getFieldKeys(detailRecord.fields); track fieldKey) {
                          <div
                            class="field-row">
                            <span class="field-name">{{fieldKey}}:</span>
                            <span class="field-value"
                              [class.reference-field]="isReferenceField(detailRecord.fields[fieldKey])">
                              {{detailRecord.fields[fieldKey]}}
                            </span>
                          </div>
                        }
                      </div>
                      <!-- <div *ngIf="!isLastRecord(detailedTable.records, recordIndex)"
                      class="record-separator">
                      ----------------------
                    </div> -->
                  </div>
                }
              </div>
            }
            @if (!isLastExcelRow(i)) {
              <div class="excel-row-separator">
                <hr>
                </div>
              }
            </div>
          }
        </div>
      </mat-tab>

      <!-- Táblák szerinti előnézet -->
      <mat-tab label="Táblák szerinti nézet">
        <div class="tables-view">
          @for (tableName of getTableNames(); track tableName) {
            <mat-expansion-panel
              class="table-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>table_chart</mat-icon>
                  {{getTableDisplayName(tableName)}}
                </mat-panel-title>
                <mat-panel-description>
                  {{getRecordCountForTable(tableName)}} rekord
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="table-content">
                <!-- Tábla séma információk -->
                <div class="table-schema">
                  <h4>Tábla séma:</h4>
                  <div class="schema-fields">
                    @for (schemaField of getSchemaFieldsForTable(tableName); track schemaField) {
                      <div
                        class="schema-field"
                        [class.id-field]="schemaField.is_id_field"
                        [class.auto-generated]="schemaField.is_auto_generated"
                        [class.mapped-field]="isFieldMapped(schemaField.value)">
                        <div class="field-info">
                          <span class="field-name">{{schemaField.label}}</span>
                          <span class="field-type">({{schemaField.type}})</span>
                          <div class="field-badges">
                            @if (schemaField.required) {
                              <span class="badge required">Kötelező</span>
                            }
                            @if (schemaField.is_id_field) {
                              <span class="badge id-field">ID</span>
                            }
                            @if (schemaField.is_auto_generated) {
                              <span class="badge auto-gen">Auto</span>
                            }
                            @if (isFieldMapped(schemaField.value)) {
                              <span class="badge mapped">Párosítva</span>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div class="field-mappings">
                  <h4>Párosított mezők:</h4>
                  <mat-chip-set>
                    @for (field of getFieldsForTable(tableName); track field) {
                      <mat-chip
                        color="primary">
                        {{getFieldDisplayName(field)}}
                      </mat-chip>
                    }
                  </mat-chip-set>
                </div>
                @if (getSampleDataForTable(tableName).length > 0) {
                  <div class="sample-data">
                    <h4>Minta adatok:</h4>
                    <div class="sample-records">
                      @for (record of getSampleDataForTable(tableName); track record; let i = $index) {
                        <div
                          class="sample-record"
                          [class.even]="i % 2 === 0">
                          <div class="record-header">
                            <strong>{{record.rowIndex}}. sor</strong>
                          </div>
                          <div class="record-fields">
                            @for (field of getFieldsForTable(tableName); track field) {
                              <div
                                class="field-value">
                                <span class="field-name">{{getFieldDisplayName(field)}}:</span>
                                <span class="field-data">{{getFieldValue(record, tableName, field)}}</span>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Többértékű mezők -->
                @if (getMultiValueEntriesForTable(tableName).length > 0) {
                  <div class="multi-value-section">
                    <h4>Többértékű mezők (külön rekordok):</h4>
                    @for (entry of getMultiValueEntriesForTable(tableName); track entry) {
                      <div class="multi-value-entry">
                        <div class="multi-value-header">
                          <strong>{{getFieldDisplayName(entry.fieldName)}}</strong>
                          <span class="separator-info">(elválasztó: "{{entry.separator}}")</span>
                          <span class="record-count-info">→ {{entry.recordCount || entry.values.length}} db rekord</span>
                        </div>
                        <mat-chip-set class="value-chips">
                          @for (value of entry.values; track value; let i = $index) {
                            <mat-chip
                              [color]="i === 0 ? 'primary' : 'accent'">
                              {{value}}
                              @if (i === 0) {
                                <span class="record-label">(1. rekord)</span>
                              }
                              @if (i > 0) {
                                <span class="record-label">({{i + 1}}. rekord)</span>
                              }
                            </mat-chip>
                          }
                        </mat-chip-set>
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }
        </div>
      </mat-tab>

      <!-- Sorok szerinti előnézet -->
      <mat-tab label="Sorok szerinti nézet">
        <div class="rows-view">
          @for (record of data.processedData | slice:0:3; track record; let i = $index) {
            <mat-expansion-panel
              class="row-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>table_rows</mat-icon>
                  {{record.rowIndex}}. sor
                </mat-panel-title>
                <mat-panel-description>
                  {{getTableCountForRecord(record)}} táblába kerül
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="row-content">
                @for (tableName of getTableNamesForRecord(record); track tableName) {
                  <div class="table-section">
                    <h4>{{getTableDisplayName(tableName)}}</h4>
                    <div class="table-fields">
                      @for (field of getFieldKeysForTable(record, tableName); track field) {
                        <div
                          class="field-row">
                          <span class="field-label">{{getFieldDisplayName(field)}}:</span>
                          <span class="field-value">{{record.tables[tableName].fields[field]}}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Többértékű bejegyzések ehhez a sorhoz -->
                @if (record.multiValueEntries.length > 0) {
                  <div class="multi-value-records">
                    <h4>Többértékű mezők (külön rekordok keletkeznek):</h4>
                    @for (entry of record.multiValueEntries; track entry) {
                      <div class="multi-value-record">
                        <div class="multi-value-record-header">
                          <strong>{{getTableDisplayName(entry.tableName)}} - {{getFieldDisplayName(entry.fieldName)}}:</strong>
                          <span class="record-count-badge">{{entry.recordCount || entry.values.length}} db rekord</span>
                        </div>
                        <div class="record-breakdown">
                          @for (value of entry.values; track value; let i = $index) {
                            <div class="individual-record">
                              <span class="record-number">{{i + 1}}. rekord:</span>
                              <mat-chip [color]="i === 0 ? 'primary' : 'accent'">
                                {{value}}
                              </mat-chip>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <!-- Progress bar feltöltés közben -->
    @if (isUploading) {
      <div class="upload-progress-container">
        <div class="progress-info">
          <mat-icon class="spinning">sync</mat-icon>
          <span class="progress-text">
            Feltöltés folyamatban: {{estimatedCurrentRecord}} / {{totalRecordsToUpload}} cég
          </span>
          <span class="progress-percentage">{{uploadProgress | number:'1.0-0'}}%</span>
        </div>
        <mat-progress-bar
          mode="determinate"
          [value]="uploadProgress"
          color="primary">
        </mat-progress-bar>
        <div class="progress-remaining">
          Még hátralévő: {{totalRecordsToUpload - estimatedCurrentRecord}} cég
        </div>
      </div>
    }

    <div class="action-buttons" [class.hidden]="isUploading">
      <button mat-button (click)="onCancel()" [disabled]="isUploading">
        <mat-icon>close</mat-icon>
        Bezárás
      </button>
      <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="isUploading">
        <mat-icon>upload</mat-icon>
        Adatok Feltöltése
      </button>
    </div>
  </mat-dialog-actions>
</div>
